import { useMenu } from 'src/contexts/menu-context'
import type { ParentAndLinkItemProps } from '../../../global-navigation'
import { Basic } from './Basic'
import { WithLogo } from './WithLogo'

export const ParentItem = ({
  item,
  type,
  position,
}: ParentAndLinkItemProps) => {
  const { handleDispatch } = useMenu()

  return (
    <div
      className="py-2"
      onClick={() => {
        type &&
          typeof position === 'number' &&
          typeof item.label === 'string' &&
          handleDispatch(type, position, item.label, Number(type) + 1)
      }}
      key={`list-item-${item.label}`}
    >
      {item.logoImage ? (
        <WithLogo item={item} position={position} />
      ) : (
        <Basic item={item} position={position} />
      )}
    </div>
  )
}
